import { BASE_URL } from "../../App";
import DynamicTable from '../Reusable/DynamicTable';
import CustomTextField from "../Reusable/Numerictext";
import CustomButton from "../Reusable/CustomButton";
// import SwitchWithState from './Reusable/Switch';
import { SelectNormal, SelectSearch, MultipleSelect } from '../Reusable/SelectBox';
import { Row, Col } from 'antd';
import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import Typography from '@mui/material/Typography';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, MenuItem,Backdrop, CircularProgress, } from '@mui/material';
import Switch from '@mui/material/Switch';
import Stack from '@mui/material/Stack';
import Swal from 'sweetalert2';
import axios from 'axios';
import Autocomplete from '@mui/material/Autocomplete';

export default function UserCreateTable() {
    const navigate = useNavigate();
    const [tableData, setTableData] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [isCreateUserPopupOpen, setCreateUserPopupOpen] = useState(false);
    const [isViewPopupOpen, setViewPopupOpen] = useState(false);
    const [editedRowData, setEditedRowData] = useState(null);
    const [editingRow, setEditingRow] = useState(null);
    const [viewData, setViewData] = useState(null);
    const [FunctionnameList, setFunctionnameList] = useState([]);
    const [YEARDETAILSList, setYEARDETAILSList] = useState([]);


    const [editedUser, setEditedUser] = useState({
        STARTNO: 0, // or the initial value for Start No
        CURRENT_NO: 0, // or the initial value for Current No
    });

    const fetchData = () => {
        setOpen(true);
        axios.post(BASE_URL + '/documentNumberRangeList')
            .then(response => {
                if (response.status === 200) {
                    setTableData(response.data.DOCUMENT_NUMBERS);
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                }
                setOpen(false);
            })
            
            .catch(error => {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: `Error: ${error.response.data.message}`
                    });
                } else if (error.request) {
                    // console.error('No response received');
                } else {
                    //console.error('Error setting up the request:', error.message);
                }
                setOpen(false);
            });
    };

    const handleStartNoChange = (e) => {
        let newValue = e.target.value.trim() === '' ? '' : parseInt(e.target.value, 10);
        newValue = newValue >= 0 || newValue === '' ? newValue : 0; // Ensure non-negative value or empty string
        if (newValue <= editedUser.CURRENT_NO || newValue === '') {
            setEditedUser({ ...editedUser, STARTNO: newValue });
        } else {
            //console.error("Start Number should be less than or equal to Current Number");
        }
    };

    const handleCurrentNoChange = (e) => {
        const newValue = parseInt(e.target.value, 10);

        if (!isNaN(newValue) && newValue >= editedUser.STARTNO) {
            setEditedUser({ ...editedUser, CURRENT_NO: newValue });
        } else {

        }
    };
    const DROPDOWNAPI = async () => {
        try {
            const response = await axios.post(BASE_URL + '/documentnorangeonload')

            const responseData = response.data;


            const FUNCTION = responseData.FUNCTIONNAME || [];
            setFunctionnameList(FUNCTION);

            const YEAR = responseData.YEARDETAILS || [];
            setYEARDETAILSList(YEAR);


        } catch (error) {
        }
    };

    const Branch_code = localStorage.getItem("BRANCH_CODE");
    const login_id = localStorage.getItem("LOGIN_ID");
    
    useEffect(() => {
        if (!login_id || !Branch_code) {
            Swal.fire({
                icon: "warning",
                text: 'Login Failed !'
            });
            localStorage.clear()
            navigate('/')
            navigate('/Login')
        } else {
            fetchData();
            DROPDOWNAPI();
        }
    }, []);
   

    const openCreateUserPopup = (formattedRowData) => {
        setCreateUserPopupOpen(true);
        setEditedRowData(formattedRowData);
    };

    const handleViewEditClick = (formattedRowData) => {
        setViewData(formattedRowData);
        setViewPopupOpen(true);
    };

    const handleReload = () => {
        //alert(1);
        fetchData();
        
    }

    return (
        <>
            <DynamicTable data={tableData} onEditClick={openCreateUserPopup} onViewClick={handleViewEditClick} />
            {isCreateUserPopupOpen && (
                <EditUserPopup
                    user={editedRowData}
                    FunctionnameList={FunctionnameList}
                    YEARDETAILSList={YEARDETAILSList}
                    // setTableData={setTableData}
                    onClose={() => {
                        setCreateUserPopupOpen(false);
                        setEditedRowData(null);
                    }}
                    onSave={() => handleReload()}
                />
            )}
            {editingRow && (
                <EditUserPopup
                    FunctionnameList={FunctionnameList}
                    YEARDETAILSList={YEARDETAILSList}
                    user={editingRow.original}
                    // setTableData={setTableData}
                    onClose={() => setEditingRow(null)}
                    onSave={() => handleReload()}
                />
            )}
            {isViewPopupOpen && (
                <ViewDataPopup
                    data={viewData}
                    onClose={() => setViewPopupOpen(false)}
                />
            )}
             <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open} >
            <CircularProgress color="inherit" />
          </Backdrop>
        </>
    );
}

const EditUserPopup = ({ user, onClose, FunctionnameList, YEARDETAILSList, onSave }) => {
    const [editedUser, setEditedUser] = useState({ ...user });
    const isCreateMode = !user;


    const Year_Options = YEARDETAILSList ? YEARDETAILSList.map((type) => ({
        Value: type.CODE,
        Label: type.DESCRIPTION,
    })) : [];

    useEffect(() => {
        if (!user && YEARDETAILSList.length > 0) {
            setEditedUser(prevState => ({
                ...prevState,
                CODE: YEARDETAILSList[0].CODE, // Set the default value to the first year in the list
            }));
        }
    }, [user, YEARDETAILSList]);
    // const defaultValue = Year_Options.length > 0 ? Year_Options[0].Value : null;

    const Function_Options = FunctionnameList ? FunctionnameList.map((type) => ({
        Value: type.SUBMENUCODE,
        Label: type.DESCRIPTION,
    })) : [];

    const [inputs, setInputs] = useState({
        FUNCTION_CODE: '', DESCRIPTION: '', CODE: '', STARTNO: '', LOGIN_ID: '', CREATEDBY: 'ADMIN'
    });

    const handleChange = (fieldName) => (event) => {

        const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        setEditedUser((prev) => ({ ...prev, [fieldName]: value }));
        setInputs({ ...inputs, [event.target.name]: event.target.value });
        setEditedUser({
            ...editedUser,
            [fieldName]: value,
        });
    };
    const handleStartNoChange = (e) => {
        let newValue = e.target.value.trim() === '' ? '' : parseInt(e.target.value, 10);
        newValue = newValue >= 1 || newValue === '' ? newValue : 1; // Ensure value is either empty or >= 1
        setEditedUser({ ...editedUser, STARTNO: newValue, CODE: editedUser.CODE });
    };

    const handleSave = async () => {
        const selectedItem = FunctionnameList.find((deepan) => deepan.SUBMENUCODE === editedUser.FUNCTION_CODE);
        if (selectedItem) {
            // alert(`Selected Item Code: ${editedUser.FUNCTION_CODE}, Description: ${selectedItem.DESCRIPTION}`);
        } else {
            const selectedItem = FunctionnameList.find((deepan) => deepan.SUBMENUCODE === editedUser.SUBMENUCODE);
            //alert(editedUser.FUNCTION_CODE);
            // alert ('No item selected!');
        }
        // var LOGINID = localStorage.getItem('LOGIN_ID')
        const login_id = localStorage.getItem("LOGIN_ID");

        const data = {
            company_code: '1000',
            function_code: editedUser.FUNCTION_CODE,
            description: selectedItem.DESCRIPTION,
            f_year: editedUser.CODE,
            start_no: editedUser.STARTNO,
            login_id: login_id
            // other properties...
        };

        const update = {
            function_code: editedUser.FUNCTION_CODE,
            f_year: editedUser.FYEAR,
            start_no: editedUser.STARTNO,
            login_id: login_id,
            // other properties...
        };

        try {
            let response;
            if (user) {
                if (update.start_no >= editedUser.CURRENT_NO) {
                    response = await axios.post(BASE_URL + '/documentnumberrangeupdate', update);
                    onSave();
                    onClose();
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        allowOutsideClick:false,
                        position: 'center',
                        timer: 3000,
                        showConfirmButton: false,
                        timerProgressBar: true,
                        text: 'Start Number should be less than or equal to Current Number',

                    }).then(() => {
                        onClose();
                                     // Close the popup after displaying the error message
                    });
                    return;
                }
            } else {
                response = await axios.post(BASE_URL + '/documentnumberrangecreate', data);

            }
            Swal.fire({
                icon: 'success',
                text: response.data.text || 'Data saved successfully!',
            }).then(() => {
                onSave();
                onClose();
                //; // Call onSave after success message is displayed
            });
        } catch (error) {
            // Handle errors
            if (error.response) {
                
                const errorMessages = error.response.data.message;
                const errorMessageList = errorMessages.map((message, index) => `${index + 1}. ${message}`).join('\n');
                Swal.fire({
                    allowOutsideClick:false,
                    position: 'top-end',
                  icon: 'error',
                  title: 'Error',
                  text: errorMessageList,
                  timer: 3000,
                  showConfirmButton: false,
                  timerProgressBar: true,
                  
                });
                return;
            } else if (error.request) {
                // The request was made but no response was received
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'No response received from the server.',
                });
            } else {
                // Something happened in setting up the request that triggered an Error
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Error setting up the request. Please try again.',
                });
            }
        } finally {
            onClose()
             // Ensure that onClose is always called, regardless of success or error
        }
    }

    return (
        <Dialog open={true} onClose={onClose} maxWidth="sm" fullWidth sx={{ justifyContent: 'center' }} BackdropProps={{ invisible: true }} >
            <DialogTitle><u><b>{user ? 'Edit' : ' Document Number Range'}</b></u></DialogTitle>
            <DialogContent>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                    <div class="col-lg form-group">
                        {/* <SelectNormal
                            label="DESCRIPTION"
                            options={Function_Options}
                            value={editedUser.FUNCTION_CODE}
                            onChange={handleChange('FUNCTION_CODE')}
                        /> */}
                        {!!user ? (

                            <SelectNormal
                                readOnly={true}
                                label="DESCRIPTION"
                                options={Function_Options}
                                value={editedUser.FUNCTION_CODE}
                                onChange={handleChange('FUNCTION_CODE')}
                            />
                        ) : (
                            <SelectSearch
                                label="DESCRIPTION"
                                options={Function_Options}
                                value={editedUser.FUNCTION_CODE}
                                onChange={(newValue) => setEditedUser({ ...editedUser, FUNCTION_CODE: newValue })}
                                // onChange={handleChange('FUNCTION_CODE')}
                            />
                        )}



                    </div>
                </Typography>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>

                    <div>
                        {!!user ? (
                            <SelectNormal
                                readOnly={true}
                                label="Year"
                                options={Year_Options}
                                value={editedUser.FYEAR}
                                onChange={handleChange('CODE')}
                            />
                            // <CustomTextField
                            //     id="StartNo"
                            //     label="Year"
                            //     name="Year"
                            //     variant="outlined"
                            //     value={editedUser.FYEAR}
                            //     onChange={handleChange('CODE')}


                            // />
                        ) : (
                            <SelectSearch
                            label="Year"
                            options={Year_Options}
                            value={editedUser.CODE || (Year_Options.length > 0 ? Year_Options[0].Value : null)} // Set the default value to the first option if editedUser.CODE is falsy
                            onChange={(newValue) => setEditedUser({ ...editedUser, CODE: newValue })}
                        />
                        )}


                    </div>
                    <div>

                    </div>
                </Typography>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
    <div style={{ display: 'flex', gap: '1rem' }}>
        <div className="col-lg-6 form-group">
            <CustomTextField
                id="StartNo"
                label="Start No"
                name="STARTNO"
                variant="outlined"
                type="number"
                inputProps={{
                    inputMode: 'numeric',
                    pattern: '[0-9]*',
                    style: {
                        MozAppearance: 'textfield',
                        appearance: 'textfield',
                        color: editedUser.CURRENT_NO > editedUser.STARTNO ? 'red' : 'inherit', // Apply red color if CURRENT_NO < STARTNO
                    },
                }}
                

                value={editedUser.STARTNO}
                onChange={handleStartNoChange}
            />
        </div>
        {user && (
            <div className="col-lg form-group">
                <CustomTextField
                    id="CurrentNo"
                    label="Current No"
                    variant="outlined"
                    name="CURRENT_NO"
                    type="number"
                    inputProps={{
                        inputMode: 'numeric',
                        pattern: '[0-9]*',
                        style: {
                            MozAppearance: 'textfield',
                            appearance: 'textfield',
                            color: editedUser.CURRENT_NO > editedUser.STARTNO ? 'red' : 'inherit', // Apply red color if CURRENT_NO < STARTNO
                        },
                    }}
                    value={editedUser.CURRENT_NO}
                    readOnly
                />
            </div>
        )}
    </div>
</Typography>
                <Row>
                </Row>
            </DialogContent>
            <center>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <Stack direction="row" spacing={2} sx={{ width: '100%', maxWidth: '400px' }}>
                            <CustomButton
                                label={user ? 'Save' : 'Create'}
                                onClick={handleSave}
                                variant="outlined"
                                size="medium"
                                height={40}
                                width="200px"
                                borderRadius="8px"
                                type="submit"
                                sx={{ flexGrow: 1 }}

                            />
                            <CustomButton
                                label="Cancel"
                                onClick={onClose}
                                variant="outlined"
                                size="medium"
                                height={40}
                                width="200px"
                                borderRadius="8px"
                                type="submit"
                                sx={{ flexGrow: 1 }}
                                color="error"
                            />
                        </Stack>
                        <br />
                    </div>
                </Typography>
                <br></br>
            </center>
           
        </Dialog >
    );
};

const ViewDataPopup = ({ data, onClose }) => {
    return (
        <Dialog open={true} onClose={onClose} maxWidth="sm" fullWidth sx={{ justifyContent: 'center' }}>
            <DialogTitle><u><b>View </b></u></DialogTitle>
            <DialogContent>
                <Row>
                    <Col xs={22} sm={10}>
                        <TextField label="DESCRIPTION" fullWidth value={data.DESCRIPTION} margin="normal" InputProps={{ readOnly: true, }} />
                    </Col>
                    <Col xs={4} sm={2}></Col>
                    <Col xs={22} sm={10}>
                        <TextField label="YEAR" fullWidth value={data.FYEAR} margin="normal" InputProps={{ readOnly: true, }} />
                    </Col>
                </Row>
                <Row>
                    <Col xs={22} sm={10}>
                        <TextField label="START NO" fullWidth value={data.STARTNO} margin="normal" InputProps={{ readOnly: true, }} />
                    </Col>
                    <Col xs={4} sm={2}></Col>
                    <Col xs={22} sm={10}>
                        <TextField label="CURRENT NO" fullWidth value={data.CURRENT_NO} margin="normal" InputProps={{ readOnly: true, }} />
                    </Col>
                </Row>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center' }}>
                <Stack direction="row" spacing={2} sx={{ width: '100%', maxWidth: '200px' }}>
                    <CustomButton
                        label="close"
                        onClick={onClose}
                        variant="outlined"
                        fullWidth
                        width="400px"
                    />
                </Stack>
            </DialogActions>
            <br></br>
        </Dialog>

    );
};